import { Feature } from '../../components/feature';
import Button from '../../components/Button';

export default function Startup() {
  return <Feature
        badge={"AI FOR STARTUPS - SCHOOLS"}
        title={"Turn Your School Idea Into a Smart Educational Business"}
        description={
          <>
            <p>
              Start your dream school easily with SooMuch.ai — India’s first AI‑powered all‑in‑one system made specially for schools. If you are starting your first school, SooMuch.ai gives you a full team of AI Experts that work 24×7 for your school — from marketing and teaching to operations, legal, and support.
            </p>
          </>
        }
        imageAlt="startup"
        imageQuery="images/new-landing-page/aiForStartupv2.png"
        cta={
          <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
              <Button label='Activate AI for Startups' type='gradient' />
              <Button label="Join Live Webinar" type='outlined' />
            </div>
        }
      />
}